import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ce3l13q1j: FaireBrandEntity = {
  token: "b_4ce3l13q1j",
  type: "brand",
  name: "Sunwarrior",
  avatarUrl:
    "https://cdn.faire.com/fastly/b62d35dd0c86c854f8394c8d6819b5c9ff139eb0cdba15ded871b27c6db66256.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/99781109aa96e242f6f7504a53fe05ab9f408bba5ac7f09cfaf88d254ac3908a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b62d35dd0c86c854f8394c8d6819b5c9ff139eb0cdba15ded871b27c6db66256.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/99781109aa96e242f6f7504a53fe05ab9f408bba5ac7f09cfaf88d254ac3908a.png",
  location: "Washington, UT, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 135,
  isInsider: true,
  description:
    "At Sunwarrior, we believe wellness should feel good—inside and out. Proudly manufactured in Southern Utah, our clean, plant-based supplements are crafted to fuel your body with everything it needs to thrive—from collagen-building blends and magnesium-rich formulas to our best-selling vegan proteins. We oversee every step of the process to ensure exceptional quality, purity, and performance.\n\nOur mission is simple: to help people feel amazing every day. That means creating supplements that not only taste great but deliver real results—powered by nature and backed by science. We’re here to replenish what modern diets leave behind with ingredients rich in antioxidants, enzymes, minerals, and phytonutrients.\n\nWhen you choose Sunwarrior, you're choosing products that are clean, effective, and made to support your healthiest, most vibrant life.\n\nExplore our other wellness-driven brands on Faire:\n • The Organic Skin Co.\n • Ready Pet Go!\n • BioSchwartz\n • Vitauthority\n• Nature's Craft\n• M3 Naturals\n• Havasu\n• Growve Shop",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:23.131Z",
    importedBy: "entity-db-cli",
  },
};
